export const LOCATION_CHANGE = '@router/location-change';
